import service from '../utils/request.js'


//获取物品分类
export function getGood_category (params) {
  return service({ url: 'system/weixin/good/category', method: 'get', params });
}
/* 产品分类 */
export function getGoodCategory (params) {
  return service({ url: 'system/dict/query', method: 'get', params });
}
//获取物品列表
export function getGood_list (params) {
  return service({ url: 'system/weixin/good/list', method: 'get', params })
}
//订单支付
export function getOrderPayParams (data) {
  return service({ url: 'system/weixin/pay/params', method: 'post', data });
}


export function toStoreList (params) {
  return service({ url: 'system/weixinb/procurementmall/list', method: 'get', params });
}

// 采购商城提交订单
export function toPostStore (data) {
  return service({ url: 'system/procurement/procurementmall/submit', method: 'post', data });
}


// 搜索
export function get_search (params) {
  return service({ url: 'system/procurement/procurementmall/search', method: 'get', params });
}
// 关键词搜索
export function get_keyword (params) {
  return service({ url: 'system/procurement/keywords', method: 'get', params });
}

// 轮播
export function get_carousel (params) {
  return service({ url: 'system/procurement/carousel/list', method: 'get', params });
}
// 查询购物车
export function get_cart_list (params) {
  return service({ url: 'system/procurement/commodity/list', method: 'get', params });
}

// 添加购物车
export function get_add_cart (data) {
  return service({ url: 'system/procurement/add/commodity', method: 'post', data });
}
// 修改购物车
export function get_alter_cart (data) {
  return service({ url: 'system/procurement/shoppingcart/management', method: 'post', data });
}
// 推荐板块
export function get_sector (params) {
  return service({ url: 'system/procurement/recommendation/sector', method: 'get', params });
}

// 商品详情
export function get_details (params) {
  return service({ url: 'system/procurement/commodity/details', method: 'get', params });
}

// 订单记录
export function get_history (params) {
  return service({ url: 'system/procurement/procurement/list', method: 'get', params });
}
export function get_commodity_details(params) {
  return service({ url: 'system/procurement/commodity/details', method: 'get', params });
}



export function get_add_autoPlay(data) {
  return service({ url: 'system/procurement/add/carousel', method: 'post', data });
}
export function edit_carousel(data) {
  return service({ url: 'system/procurement/edit/carousel', method: 'post', data });
}

export function get_good_list(params) {
  return service({ url: 'system/procurement/procurement/commodity/list', method: 'get', params });
}
// 删除轮播
export function del_carousel(data) {
  return service({ url: 'system/procurement/del/carousel', method: 'post', data });
}



// 热词列表
export function get_hottopics (params) {
  return service({ url: 'system/procurement/hottopics/list', method: 'get', params });
}
// 添加热词
export function add_hottopics(data) {
  return service({ url: 'system/procurement/add/hottopics', method: 'post', data });
}
// 添加热词
export function homepagedata(data) {
  return service({ url: 'system/procurement/homepagedata', method: 'post', data });
}
export function recommended(data) {
  return service({ url: 'system/procurement/addition/recommended', method: 'post', data });
}
export function subtable(data) {
  return service({ url: 'system/procurement/addition/recommended/subtable', method: 'post', data });
}
export function choice(params) {
  return service({ url: 'system/procurement/recommendation/choice', method: 'get', params });
}
export function datalist(params) {
  return service({ url: 'system/procurement/recommend/data/list', method: 'get', params });
}
export function smallcarousellist(params) {
  return service({ url: 'system/procurement/smallcarousel/list', method: 'get', params });
}
export function jurisdiction(params) {
  return service({ url: 'system/procurement/management/backend', method: 'get', params });
}
export function shailist(params) {
  return service({ url: 'system/procurement/smallcarousel/shai/list', method: 'get', params });
}
export function edittranslatet (data) {
  return service({ url: 'system/procurement/edit/translate', method: 'post', data });
}
export function editsubtable (data) {
  return service({ url: 'system/procurement/edit/subtable', method: 'post', data });
}
export function slotsubtable (data) {
  return service({ url: 'system/procurement/recommendedslot/subtable', method: 'post', data });
}
export function commodltyname (params) {
  return service({ url: 'system/procurement/commodity/name', method: 'get', params });
}
export function samesort (params) {
  return service({ url: 'system/procurement/same/sort', method: 'get', params });
}


